import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate, money } from "@/lib/format";

const TONE = { Pending: "bg-amber-100 text-amber-900", Succeeded: "bg-emerald-100 text-emerald-800", Failed: "bg-red-100 text-red-800" };

export const OnlinePayments = ({ loanId, refreshKey }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/loans/${loanId}/online-payments`).then((r) => setItems(r.data.items)); }, [loanId, refreshKey]);
  if (!items.length) return null;
  return (
    <div className="mb-6 rounded-lg border bg-card" data-testid="online-payments">
      <div className="border-b px-5 py-3 text-sm font-semibold">Online payments</div>
      <ul className="divide-y">
        {items.map((t) => (
          <li key={t.id} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-5 py-3 text-sm" data-testid={`online-payment-${t.id}`}>
            <span className="flex flex-wrap items-center gap-2">
              <span className="num font-semibold">{money(t.amount_cents)}</span>
              <span data-testid={`online-payment-method-${t.id}`}>{t.method}</span>
              <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${TONE[t.status] || "bg-muted text-muted-foreground"}`} data-testid={`online-payment-status-${t.id}`}>{t.status}</span>
              {t.message && <span className="text-xs text-muted-foreground">{t.message}</span>}
              {t.failure_reason && <span className="text-xs text-destructive">{t.failure_reason}</span>}
            </span>
            <span className="text-xs text-muted-foreground">started {fmtDate(t.started_on)}{t.stripe_payment_id && <span className="mono"> · {t.stripe_payment_id}</span>}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
